export const sponsor = {
  title: {
    presence: {
      allowEmpty: false
    }
  },
  namespace: {
    presence: {
      allowEmpty: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/validators/sponsor.js